export default class ProductLabel {
    static init(): void {
        const categoryItems = document.querySelectorAll('.category-item');

        categoryItems.forEach((item) => {
            const labels = item.querySelectorAll('.category-item__tags .category-item__tag');

            labels.forEach((label, index) => {
                if (index >= 3) {
                    label.classList.add('none');
                }
            });
        });
    }
}
